export const baseUrl = process.env.NODE_ENV === "production" ? "https://bhuban.shop" : "http://127.0.0.1:8000"
// export const baseUrl = "https://bhuban.shop"
export const api_service_path = {
    setting: "api/setting",
    auth: "user/auth",
    class_room: "api/class",
    admission: "api/admission",
    user: "api/user",
    upload_content: "api/imageUpload",
    download: "api/download",
    feeCollection: "api/fee",
    checkPass: "api/check_pass",
    exam: "api/exam",
    student: "api/student",
    certificate: "api/certificates",
    lectures: "api/lectures"
}